import { Component, ChangeDetectionStrategy, Input, HostBinding } from "@angular/core";

// adapted from https://github.com/angular/components/blob/master/src/material/list/list
@Component({
  selector: "onsip-fixed-width-card-list",
  templateUrl: "./fixed-width-card-list.component.html",
  styleUrls: ["./fixed-width-card-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FixedWidthCardListComponent {
  @Input() set width(width: string) {
    this._width = parseInt(width) + "px"; // accept width="123" AND width="123px"
  }

  @HostBinding("style.width")
  @HostBinding("style.max-width")
  _width!: string;
}
